import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/cca-h5/dist',
    routes: [{
            path: '/',
            name: 'root',
            redirect: {
                name: 'Index',
            },
        },
        {
            path: '/uploadimg',
            name: 'uploadimg',
            component: require('@/page/apps/isai/Uploadimg'),
        },
        {
            path: '/update',
            name: 'update',
            component: require('@/page/index/update'),
        },
        {
            path: '/index',
            name: 'Index',
            component: require('@/page/index/Index'),
        },
        {
            path: '/h5Index',
            name: 'H5Index',
            component: require('@/page/index/H5Index'),
        },

        {
            path: '/login',
            name: 'login',
            component: require('@/page/index/login'),
        },
        {
            path: '/loginBySms',
            name: 'loginBySms',
            component: require('@/page/index/loginBySms'),
        },
        {
            path: '/loginByUsername',
            name: 'loginByUsername',
            component: require('@/page/index/loginByUsername'),
        },
        {
            path: '/loginDianxin',
            name: 'loginDianxin',
            component: require('@/page/index/loginDianxin'),
        },
        {
            path: '/regist',
            name: 'regist',
            component: require('@/page/index/regist'),
        },
        {
            path: '/loginSuccess',
            name: 'loginSuccess',
            component: require('@/page/index/loginSuccess'),
        },
        {
            path: '/cdakejian-apply',
            name: 'CDakejianApply',
            component: require('@/page/apps/cdakejian/DakejianApply'),
        },
        {
            path: '/cdakejian-apply-success',
            name: 'CDakejianApplySuccess',
            component: require('@/page/apps/cdakejian/DakejianApplySuccess'),
        },
        {
            path: '/songpei-apply-form-basic',
            name: 'SongpeiApplyFormBasic',
            component: require('@/page/apps/songpei/SongpeiApplyFormBasic'),
        },
        {
            path: '/songpei-apply-list',
            name: 'SongpeiApplyList',
            component: require('@/page/apps/songpei/SongpeiApplyList'),
        },
        {
            path: '/songpei-apply-form-step2',
            name: 'SongpeiApplyFormStep2',
            component: require('@/page/apps/songpei/SongpeiApplyFormStep2'),
        },
        {
            path: '/songpei-apply-form-success',
            name: 'SongpeiApplyFormSuccess',
            component: require('@/page/apps/songpei/SongpeiApplyFormSuccess'),
        },
        {
            path: '/songpei-exame',
            name: 'SongpeiExame',
            component: require('@/page/apps/songpei/SongpeiExame'),
        },
        {
            path: '/cert-club-result',
            name: 'CertClubResult',
            component: require('@/page/apps/club/CertClubResult'),
        },
        {
            path: '/club-bind',
            name: 'ClubBind',
            component: require('@/page/apps/club/ClubBind'),
        },
        {
            path: '/club-apply',
            name: 'ClubApply',
            component: require('@/page/apps/club/ClubApply'),
        },
        {
            path: '/club-apply-yanshou',
            name: 'ClubApplyYanshou',
            component: require('@/page/apps/club/ClubApplyYanshou'),
        },
        {
            path: '/club-jianshe-list',
            name: 'ClubJiansheList',
            component: require('@/page/apps/club/ClubJiansheList'),
        },
        {
            path: '/club-jianshe-step1',
            name: 'ClubJiansheStep1',
            component: require('@/page/apps/club/ClubJiansheStep1'),
        },
        {
            path: '/club-jianshe-step2',
            name: 'ClubJiansheStep2',
            component: require('@/page/apps/club/ClubJiansheStep2'),
        },
        {
            path: '/club-jianshe-step3',
            name: 'ClubJiansheStep3',
            component: require('@/page/apps/club/ClubJiansheStep3'),
        },
        {
            path: '/club-jianshe-step4',
            name: 'ClubJiansheStep4',
            component: require('@/page/apps/club/ClubJiansheStep4'),
        },
        {
            path: '/club-jianshe-hetong',
            name: 'ClubJiansheHetong',
            component: require('@/page/apps/club/ClubJiansheHetong'),
        },
        {
            path: '/club-jianshe-yanshou',
            name: 'ClubJiansheYanshou',
            component: require('@/page/apps/club/ClubJiansheYanshou'),
        },
        /*******seabert start******/
        {
            path: '/user-member-yundongyuanlist-parent',
            name: 'YundongyuanListParent',
            component: require('@/page/user/member/YundongyuanListParent'),
        },
        {
            path: '/user-member-yundongyuanlist-share',
            name: 'YundongyuanListShare',
            component: require('@/page/user/member/YundongyuanListShare'),
        },
        {
            path: '/club-index',
            name: 'ClubIndex',
            component: require('@/page/apps/club/ClubIndex'),
        },
        {
            path: '/club-search-index',
            name: 'ClubSearchIndex',
            component: require('@/page/apps/club/ClubSearchIndex'),
        },
        {
            path: '/club-detail-sihao',
            name: 'ClubDetailSihao',
            component: require('@/page/apps/club/ClubDetailSihao'),
        },
        {
            path: '/club-edit',
            name: 'ClubEdit',
            component: require('@/page/apps/club/ClubEdit'),
        },
        {
            path: '/club-shouquan-book',
            name: 'ClubShouquanBook',
            component: require('@/page/apps/club/ClubShouquanBook'),
        },
        {
            path: '/club-high-apply',
            name: 'ClubHighApply',
            component: require('@/page/apps/club/ClubHighApply'),
        },
        {
            path: '/club-high-apply-new',
            name: 'ClubHighApplyNew',
            component: require('@/page/apps/club/ClubHighApplyNew'),
        },
        {
            path: '/club-high-apply-result',
            name: 'ClubHighApplyResult',
            component: require('@/page/apps/club/ClubHighApplyResult'),
        },
        {
            path: '/club-danwei-apply',
            name: 'ClubDanweiApply',
            component: require('@/page/apps/club/ClubDanweiApply'),
        },
        {
            path: '/club-score-apply',
            name: 'ClubScoreApply',
            component: require('@/page/apps/club/ClubScoreApply'),
        },
        {
            path: '/club-score-apply-list',
            name: 'ClubScoreApplyList',
            component: require('@/page/apps/club/ClubScoreApplyList'),
        },
        {
            path: '/club-danwei-apply-result',
            name: 'ClubDanweiApplyResult',
            component: require('@/page/apps/club/ClubDanweiApplyResult'),
        },
        {
            path: '/club-detail-kaoji',
            name: 'ClubDetailKaoji',
            component: require('@/page/apps/club/ClubDetailKaoji'),
        },
        {
            path: '/club-detail-score',
            name: 'ClubDetailScore',
            component: require('@/page/apps/club/ClubDetailScore'),
        },
        {
            path: '/club-detail-danwei',
            name: 'ClubDetailDanwei',
            component: require('@/page/apps/club/ClubDetailDanwei'),
        },
        {
            path: '/club-detail-fengcai',
            name: 'ClubDetailFengcai',
            component: require('@/page/apps/club/ClubDetailFengcai'),
        },
        {
            path: '/club-detail-shenbao',
            name: 'ClubDetailShenbao',
            component: require('@/page/apps/club/ClubDetailShenbao'),
        },
        {
            path: '/club-detail-sihao-apply',
            name: 'ClubDetailSihaoApply',
            component: require('@/page/apps/club/ClubDetailSihaoApply'),
        },
        {
            path: '/club-detail-sihao-apply-success',
            name: 'ClubDetailSihaoApplySuccess',
            component: require('@/page/apps/club/ClubDetailSihaoApplySuccess'),
        },
        {
            path: '/club-detail-mine',
            name: 'ClubDetailMine',
            component: require('@/page/apps/club/ClubDetailMine'),
        },
        {
            path: '/club-detail-unbind',
            name: 'ClubDetailUnbind',
            component: require('@/page/apps/club/ClubDetailUnbind'),
        },
        {
            path: '/club-detail',
            name: 'ClubDetail',
            component: require('@/page/apps/club/ClubDetail'),
        },
        {
            path: '/club-detail-base',
            name: 'ClubDetailBase',
            component: require('@/page/apps/club/ClubDetailBase'),
        },
        {
            path: '/club-detail-community',
            name: 'ClubDetailCommunity',
            component: require('@/page/apps/club/ClubDetailCommunity'),
        },
        {
            path: '/club-detail-community-add',
            name: 'ClubDetailCommunityAdd',
            component: require('@/page/apps/club/ClubDetailCommunityAdd'),
        },
        {
            path: '/club-apply-mine',
            name: 'ClubApplyMine',
            component: require('@/page/apps/club/ClubApplyMine'),
        },
        {
            path: '/qcxj-club-index',
            name: 'QcxjClubIndex',
            component: require('@/page/apps/qcxj/QcxjClubIndex'),
        },
        {
            path: '/qcxj-index2',
            name: 'QcxjIndex2',
            component: require('@/page/apps/qcxj/QcxjIndex2'),
        },
        {
            path: '/club-index2',
            name: 'ClubIndex2',
            component: require('@/page/apps/club/ClubIndex2'),
        },
        {
            path: '/qcxj-search-index',
            name: 'QcxjSearchIndex',
            component: require('@/page/apps/qcxj/QcxjSearchIndex'),
        },
        {
            path: '/qcxj-detail-info',
            name: 'QcxjDetailInfo',
            component: require('@/page/apps/qcxj/QcxjDetailInfo'),
        },
        {
            path: '/qcxj-detail-unbind',
            name: 'QcxjDetailUnbind',
            component: require('@/page/apps/qcxj/QcxjDetailUnbind'),
        },
        {
            path: '/qcxj-detail-mine',
            name: 'QcxjDetailMine',
            component: require('@/page/apps/qcxj/QcxjDetailMine'),
        },

        {
            path: '/qcxj-station-apply-mine',
            name: 'QcxjStationApplyMine',
            component: require('@/page/apps/qcxj/StationApplyMine'),
        },
        {
            path: '/qcxj-detail',
            name: 'QcxjDetail',
            component: require('@/page/apps/qcxj/QcxjDetail.vue'),
        },

        {
            path: '/qcxj-detail-base',
            name: 'QcxjDetailBase',
            component: require('@/page/apps/qcxj/QcxjDetailBase.vue'),
        },
        {
            path: '/qcxj-detail-community',
            name: 'QcxjDetailCommunity',
            component: require('@/page/apps/qcxj/QcxjDetailCommunity.vue'),
        },
        {
            path: '/qcxj-exame-apply-form-basic-mine',
            name: 'ExameApplyFormBasicMine',
            component: require('@/page/apps/qcxj/ExameApplyFormBasicMine'),
        },
        {
            path: '/qcxj-exame-apply-form-sai-mine',
            name: 'ExameApplyFormSaiMine',
            component: require('@/page/apps/qcxj/ExameApplyFormSaiMine'),
        },
        {
            path: '/qcxj-exame-apply-detail-mine',
            name: 'ExameApplyDetailMine',
            component: require('@/page/apps/qcxj/ExameApplyDetailMine'),
        },
        {
            path: '/qcxj-exame-apply-detail-share',
            name: 'ExameApplyDetailShare',
            component: require('@/page/apps/qcxj/ExameApplyDetailShare'),
        },
        {
            path: '/qcxj-detail-community-add',
            name: 'QcxjDetailCommunityAdd',
            component: require('@/page/apps/qcxj/QcxjDetailCommunityAdd.vue'),
        },
        {
            path: '/qcxj-exame-apply-list-mine',
            name: 'ExameApplyListMine',
            component: require('@/page/apps/qcxj/ExameApplyListMine'),
        },

        {
            path: '/qcxj-exame-apply-form-match',
            name: 'ExameApplyFormMatch',
            component: require('@/page/apps/qcxj/ExameApplyFormMatch'),
        },
        {
            path: '/cdakejian-list',
            name: 'DakejianList',
            component: require('@/page/apps/cdakejian/DakejianList'),
        },
        {
            path: '/cdakejian-apple-simple',
            name: 'DakejianApplySimple',
            component: require('@/page/apps/cdakejian/DakejianApplySimple'),
        },


        {
            path: '/qcxj-exame-apply-order-mine',
            name: 'ExameApplyOrderMine',
            component: require('@/page/apps/qcxj/ExameApplyOrderMine'),
        },
        /********seabert end*******/
        {
            path: '/qcxj-index',
            name: 'QcxjIndex',
            component: require('@/page/apps/qcxj/QcxjIndex'),
        },
        {
            path: '/GoodsIndex',
            name: 'GoodsIndex',
            component: require('@/page/index/GoodsIndex'),
        },
        {
            path: '/qcxj-station-apply',
            name: 'QcxjStationApply',
            component: require('@/page/apps/qcxj/StationApply'),
        },
        {
            path: '/qcxj-station-bind',
            name: 'QcxjStationBind',
            component: require('@/page/apps/qcxj/StationBind'),
        },
        {
            path: '/qcxj-station-list',
            name: 'QcxjStationList',
            component: require('@/page/apps/qcxj/StationList'),
        },
        {
            path: '/qcxj-station-result',
            name: 'QcxjStationResult',
            component: require('@/page/apps/qcxj/StationResult'),
        },
        {
            path: '/qcxj-station-cert',
            name: 'QcxjStationCert',
            component: require('@/page/apps/qcxj/StationCert'),
        },
        {
            path: '/qcxj-exame-apply-list',
            name: 'ExameApplyList',
            component: require('@/page/apps/qcxj/ExameApplyList'),
        },
        {
            path: '/qcxj-exame-apply-slist',
            name: 'ExameApplySList',
            component: require('@/page/apps/qcxj/ExameApplySList'),
        },
        {
            path: '/qcxj-exame-apply-form-basic',
            name: 'ExameApplyFormBasic',
            component: require('@/page/apps/qcxj/ExameApplyFormBasic'),
        },
        {
            path: '/qcxj-exame-apply-share-list',
            name: 'ExameApplyShareList',
            component: require('@/page/apps/qcxj/ExameApplyShareList'),
        },
        {
            path: '/qcxj-exame-score-detail',
            name: 'ExameScoreDetail',
            component: require('@/page/apps/qcxj/ExameScoreDetail'),
        },
        {
            path: '/qcxj-exame-score-form',
            name: 'ExameScoreForm',
            component: require('@/page/apps/qcxj/ExameScoreForm'),
        },
        {
            path: '/qcxj-exame-score-sai-form',
            name: 'ExameScoreSaiForm',
            component: require('@/page/apps/qcxj/ExameScoreSaiForm'),
        },
        {
            path: '/qcxj-exame-score-sai-login',
            name: 'ExameScoreSaiLogin',
            component: require('@/page/apps/qcxj/ExameScoreSaiLogin'),
        },
        {
            path: '/dexame-caipan-login',
            name: 'DexameLogin',
            component: require('@/page/apps/dexame/DexameLogin'),
        },
        {
            path: '/dexame-score',
            name: 'DexameScore',
            component: require('@/page/apps/dexame/DexameScore'),
        },
        {
            path: '/qcxj-exame-apply-join',
            name: 'ExameApplyJoin',
            component: require('@/page/apps/qcxj/ExameApplyJoin'),
        },
        {
            path: '/qcxj-exame-apply-join-detail',
            name: 'ExameApplyJoinDetail',
            component: require('@/page/apps/qcxj/ExameApplyJoinDetail'),
        },
        {
            path: '/qcxj-exame-apply-join-member-list',
            name: 'ExameApplyJoinMemberList',
            component: require('@/page/apps/qcxj/ExameApplyJoinMemberList'),
        },
        {
            path: '/qcxj-exame-apply-member-list',
            name: 'ExameApplyMemberList',
            component: require('@/page/apps/qcxj/ExameApplyMemberList'),
        },
        {
            path: '/qcxj-exame-apply-member-detail',
            name: 'ExameApplyMemberDetail',
            component: require('@/page/apps/qcxj/ExameApplyMemberDetail'),
        },
        {
            path: '/qcxj-exame-apply-order',
            name: 'ExameApplyOrder',
            component: require('@/page/apps/qcxj/ExameApplyOrder'),
        },
        {
            path: '/qcxj-exame-apply-detail',
            name: 'ExameApplyDetail',
            component: require('@/page/apps/qcxj/ExameApplyDetail'),
        },
        {
            path: '/qcxj-exame-apply-member-add-more',
            name: 'ExameApplyMemberAddMore',
            component: require('@/page/apps/qcxj/ExameApplyMemberAddMore'),
        },
        {
            path: '/qcxj-exame-apply-member-add',
            name: 'ExameApplyMemberAdd',
            component: require('@/page/apps/qcxj/ExameApplyMemberAdd'),
        },
        {
            path: '/qcxj-exame-apply-member-add-front',
            name: 'ExameApplyMemberAddFront',
            component: require('@/page/apps/qcxj/ExameApplyMemberAddFront'),
        },
        {
            path: '/sai-apply-form-step-1',
            name: 'SaiApplyFormStep1',
            component: require('@/page/apps/sai/SaiApplyFormStep1'),
        },
        {
            path: '/sai-apply-form-step-2',
            name: 'SaiApplyFormStep2',
            component: require('@/page/apps/sai/SaiApplyFormStep2'),
        },
        {
            path: '/sai-apply-form-step-3',
            name: 'SaiApplyFormStep3',
            component: require('@/page/apps/sai/SaiApplyFormStep3'),
        },
        {
            path: '/sai-apply-form-step-4',
            name: 'SaiApplyFormStep4',
            component: require('@/page/apps/sai/SaiApplyFormStep4'),
        },
        {
            path: '/sai-apply-form-step-5',
            name: 'SaiApplyFormStep5',
            component: require('@/page/apps/sai/SaiApplyFormStep5'),
        },
        {
            path: '/sai-apply-form-success',
            name: 'SaiApplyFormSuccess',
            component: require('@/page/apps/sai/SaiApplyFormSuccess'),
        },
        {
            path: '/sai-apply-fapiao',
            name: 'SaiApplyFapiao',
            component: require('@/page/apps/sai/SaiApplyFapiao'),
        },
        {
            path: '/sai-apply-beizhu',
            name: 'SaiApplyBeizhu',
            component: require('@/page/apps/sai/SaiApplyBeizhu'),
        },
        {
            path: '/sai-apply-form-success',
            name: 'SaiApplyFormSuccess',
            component: require('@/page/apps/sai/SaiApplyFormSuccess'),
        },
        {
            path: '/sai-data-list',
            name: 'SaiDateList',
            component: require('@/page/apps/sai/SaiDateList'),
        },
        {
            path: '/sai-data-list-sim',
            name: 'SaiDateListSim',
            component: require('@/page/apps/sai/SaiDateListSim'),
        },
        {
            path: '/sai-files-list',
            name: 'SaiFilesList',
            component: require('@/page/apps/sai/SaiFilesList'),
        },
        {
            path: '/sai-result',
            name: 'SaiResult',
            component: require('@/page/apps/sai/SaiResult'),
        },
        {
            path: '/sai-start-list',
            name: 'SaiStartList',
            component: require('@/page/apps/sai/SaiStartList'),
        },
        {
            path: '/zsai-apply-form-step-1',
            name: 'ZSaiApplyFormStep1',
            component: require('@/page/apps/zsai/SaiApplyFormStep1'),
        },
        {
            path: '/zsai-apply-form-step-2',
            name: 'ZSaiApplyFormStep2',
            component: require('@/page/apps/zsai/SaiApplyFormStep2'),
        },
        {
            path: '/zsai-apply-form-upload-zan',
            name: 'ZSaiApplyFormUploadZan',
            component: require('@/page/apps/zsai/SaiApplyFormUploadZan'),
        },
        {
            path: '/zsai-apply-zan-list',
            name: 'ZSaiApplyZanList',
            component: require('@/page/apps/zsai/SaiApplyZanList'),
        },
        {
            path: '/apply-331-form-step-1',
            name: 'Apply331FormStep1',
            component: require('@/page/apps/331/ApplyFormStep1'),
        },
        {
            path: '/apply-331-form-step-2',
            name: 'Apply331FormStep2',
            component: require('@/page/apps/331/ApplyFormStep2'),
        },
        {
            path: '/apply-331-form-step-3',
            name: 'Apply331FormStep3',
            component: require('@/page/apps/331/ApplyFormStep3'),
        },
        {
            path: '/tpage1',
            name: 'Tpage1',
            component: require('@/page/apps/tpage/Tpage1'),
        },
        {
            path: '/tpage2',
            name: 'Tpage2',
            component: require('@/page/apps/tpage/Tpage2'),
        },
        {
            path: '/tpage3',
            name: 'Tpage3',
            component: require('@/page/apps/tpage/Tpage3'),
        },
        {
            path: '/tpage4',
            name: 'Tpage4',
            component: require('@/page/apps/tpage/Tpage4'),
        },
        {
            path: '/tpage5',
            name: 'Tpage5',
            component: require('@/page/apps/tpage/Tpage5'),
        },
        {
            path: '/isai-apply-form-step-1',
            name: 'ISaiApplyFormStep1',
            component: require('@/page/apps/isai/SaiApplyFormStep1'),
        },
        {
            path: '/isai-apply-form-step-1-dianxin',
            name: 'ISaiApplyFormStep1Dianxin',
            component: require('@/page/apps/isai/SaiApplyFormStep1Dianxin'),
        },
        {
            path: '/isai-apply-form-fc',
            name: 'ISaiApplyFormFc',
            component: require('@/page/apps/isai/SaiApplyFormFc'),
        },
    
        {
            path: '/isai-apply-form-step-2',
            name: 'ISaiApplyFormStep2',
            component: require('@/page/apps/isai/SaiApplyFormStep2'),
        },
        {
            path: '/isai-apply-form-step-2-dianxin',
            name: 'ISaiApplyFormStep2Dianxin',
            component: require('@/page/apps/isai/SaiApplyFormStep2Dianxin'),
        },
        {
            path: '/isai-apply-form-step-2-music',
            name: 'ISaiApplyFormStep2Music',
            component: require('@/page/apps/isai/SaiApplyFormStep2Music'),
        },
        {
            path: '/isai-apply-form-famliy-step-2',
            name: 'ISaiApplyFormFamliyStep2',
            component: require('@/page/apps/isai/SaiApplyFormFamliyStep2'),
        },
        {
            path: '/isai-apply-form-step-3',
            name: 'ISaiApplyFormStep3',
            component: require('@/page/apps/isai/SaiApplyFormStep3'),
        },
        {
            path: '/isai-apply-form-step-4',
            name: 'ISaiApplyFormStep4',
            component: require('@/page/apps/isai/SaiApplyFormStep4'),
        },
        {
            path: '/isai-apply-form-step-3-admin',
            name: 'ISaiApplyFormStep3Admin',
            component: require('@/page/apps/isai/SaiApplyFormStep3Admin'),
        },
        {
            path: '/isai-apply-form-step-4-admin',
            name: 'ISaiApplyFormStep4Admin',
            component: require('@/page/apps/isai/SaiApplyFormStep4Admin'),
        },
        {
            path: '/isai-apply-form-step-5',
            name: 'ISaiApplyFormStep5',
            component: require('@/page/apps/isai/SaiApplyFormStep5'),
        },
        {
            path: '/isai-apply-form-step-bu',
            name: 'ISaiApplyFormStepBu',
            component: require('@/page/apps/isai/SaiApplyFormStepBu'),
        },
        {
            path: '/isai-apply-form-success',
            name: 'ISaiApplyFormSuccess',
            component: require('@/page/apps/isai/SaiApplyFormSuccess'),
        },
        {
            path: '/isai-apply-form-jiaolian-caipan',
            name: 'ISaiApplyFormJiaolianCaipan',
            component: require('@/page/apps/isai/SaiApplyFormJiaolianCaipan'),
        },
        {
            path: '/isai-apply-fapiao',
            name: 'SaiApplyFapiao',
            component: require('@/page/apps/isai/SaiApplyFapiao'),
        },
        {
            path: '/isai-apply-form-upload-video',
            name: 'ISaiApplyFormUploadVideo',
            component: require('@/page/apps/isai/SaiApplyFormUploadVideo'),
        },
        {
            path: '/isai-apply-form-upload-video-live',
            name: 'ISaiApplyFormUploadVideoLive',
            component: require('@/page/apps/isai/SaiApplyFormUploadVideoLive'),
        },
        {
            path: '/isai-apply-video-list',
            name: 'ISaiApplyVideoList',
            component: require('@/page/apps/isai/SaiApplyVideoList'),
        },
        {
            path: '/isai-cert-list',
            name: 'ISaiCertList',
            component: require('@/page/apps/isai/SaiCertList'),
        },
        {
            path: '/isai-apply-list',
            name: 'ISaiApplyList',
            component: require('@/page/apps/isai/SaiApplyList'),
        },
        {
            path: '/isai-apply-list-dianxin',
            name: 'ISaiApplyListDianxin',
            component: require('@/page/apps/isai/SaiApplyListDianxin'),
        },
        {
            path: '/isai-apply-famliy-list',
            name: 'ISaiApplyFamliyList',
            component: require('@/page/apps/isai/SaiApplyFamliyList'),
        },
        {
            path: '/isai-apply-detail',
            name: 'ISaiApplyDetail',
            component: require('@/page/apps/isai/SaiApplyDetail'),
        },
        {
            path: '/isai-apply-detail-dianxin',
            name: 'ISaiApplyDetailDianxin',
            component: require('@/page/apps/isai/SaiApplyDetailDianxin'),
        },
        {
            path: '/isai-apply-address',
            name: 'ISaiApplyAddress',
            component: require('@/page/apps/isai/SaiApplyAddress'),
        },
        {
            path: '/isai-apply-famliy-detail',
            name: 'ISaiApplyFamliyDetail',
            component: require('@/page/apps/isai/SaiApplyFamliyDetail'),
        },
        {
            path: '/isai-vote-list',
            name: 'ISaiVoteList',
            component: require('@/page/apps/isai/VoteList'),
        },
        {
            path: '/isai-vote-detail',
            name: 'ISaiVoteDetail',
            component: require('@/page/apps/isai/VoteDetail'),
        },
        {
            path: '/sai-confirm',
            name: 'saiConfirm',
            component: require('@/page/apps/sai/saiConfirm'),
        },
        {
            path: '/sai-confirm-detail1',
            name: 'saiConfirmDetail1',
            component: require('@/page/apps/sai/saiConfirmDetail1'),
        },
        {
            path: '/sai-confirm-detail2',
            name: 'saiConfirmDetail2',
            component: require('@/page/apps/sai/saiConfirmDetail2'),
        },
        {
            path: '/sai-confirm-detail3',
            name: 'saiConfirmDetail3',
            component: require('@/page/apps/sai/saiConfirmDetail3'),
        },
        {
            path: '/sai-confirm-detail4',
            name: 'saiConfirmDetail4',
            component: require('@/page/apps/sai/saiConfirmDetail4'),
        },
        {
            path: '/sai-confirm-detail5',
            name: 'saiConfirmDetail5',
            component: require('@/page/apps/sai/saiConfirmDetail5'),
        },
        {
            path: '/sai-confirm-detail-dinner',
            name: 'saiConfirmDetailDinner',
            component: require('@/page/apps/sai/SaiConfirmDetailDinner'),
        },
        {
            path: '/sai-confirm-manage',
            name: 'saiConfirmManage',
            component: require('@/page/apps/sai/SaiConfirmManage'),
        },
        {
            path: '/sai-confirm-qr1',
            name: 'saiConfirmQr1',
            component: require('@/page/apps/sai/SaiConfirmQr1'),
        },
        {
            path: '/sai-confirm-qr2',
            name: 'saiConfirmQr2',
            component: require('@/page/apps/sai/SaiConfirmQr2'),
        },
        {
            path: '/sai-my-sai',
            name: 'MySai',
            component: require('@/page/apps/sai/MySai'),
        },
        /********评分********/
        {
            path: '/caipan-common-login',
            name: 'CommonLogin',
            component: require('@/page/apps/score/CommonLogin'),
        },
        {
            path: '/caipan-shequ-login',
            name: 'ShequLogin',
            component: require('@/page/apps/score/ShequLogin'),
        },
        {
            path: '/caipan-common-login2',
            name: 'CommonLogin2',
            component: require('@/page/apps/score/CommonLogin2'),
        },
        {
            path: '/caipan-time-login',
            name: 'TimeLogin',
            component: require('@/page/apps/score/TimeLogin'),
        },
        {
            path: '/caipan-common-score',
            name: 'CommonScore',
            component: require('@/page/apps/score/CommonScore'),
        },
        {
            path: '/caipan-shequ-score',
            name: 'ShequScore',
            component: require('@/page/apps/score/ShequScore'),
        },
        {
            path: '/caipan-common-sscore',
            name: 'CommonSScore',
            component: require('@/page/apps/score/CommonSScore'),
        },
        {
            path: '/caipan-common-score-check',
            name: 'CommonScoreCheck',
            component: require('@/page/apps/score/CommonScoreCheck'),
        },
        {
            path: '/caipan-shequ-score-check',
            name: 'ShequScoreCheck',
            component: require('@/page/apps/score/ShequScoreCheck'),
        },
        {
            path: '/caipan-time-score',
            name: 'TimeScore',
            component: require('@/page/apps/score/TimeScore'),
        },

        {
            path: '/activity',
            name: 'Activity',
            component: require('@/page/activity/Activity'),
        },
        {
            path: '/activity-my-activity',
            name: 'MyActivity',
            component: require('@/page/apps/activity/MyActivity'),
        },
        {
            path: '/activity-activity',
            name: 'ActivityActivity',
            component: require('@/page/apps/activity/Activity'),
        },
        {
            path: '/activity-activity-detail',
            name: 'ActivityDetail',
            component: require('@/page/apps/activity/ActivityDetail'),
        },
        {
            path: '/activity-activity-content-form',
            name: 'ActivityContentForm',
            component: require('@/page/apps/activity/activityContentForm'),
        },
        {
            path: '/activity-activity-pic-order-form',
            name: 'ActivityPicOrderForm',
            component: require('@/page/apps/activity/ActivityPicOrderForm'),
        },
        {
            path: '/user-member-yundongyuanlist',
            name: 'YundongyuanList',
            component: require('@/page/user/member/YundongyuanList'),
        },
        {
            path: '/user-member-caipanlist',
            name: 'CaipanList',
            component: require('@/page/user/member/CaipanList'),
        },
        {
            path: '/user-member-jiaolianlist',
            name: 'JiaolianList',
            component: require('@/page/user/member/JiaolianList'),
        },
        {
            path: '/user-cert-certindex',
            name: 'CertIndex',
            component: require('@/page/user/cert/CertIndex'),
        },
        {
            path: '/user-cert-certdanwei',
            name: 'CertDanwei',
            component: require('@/page/user/cert/CertDanwei'),
        },
        {
            path: '/forget-cca-user',
            name: 'ForgetCcaUser',
            component: require('@/page/user/cert/ForgetCcaUser'),
        },
        {
            path: '/user-cert-certdanweibind',
            name: 'CertDanweiBind',
            component: require('@/page/user/cert/CertDanweiBind'),
        },
        {
            path: '/user-cert-certdanweiapply',
            name: 'CertDanweiApply',
            component: require('@/page/user/cert/CertDanweiApply'),
        },
        {
            path: '/user-cert-certdanweiresult',
            name: 'CertDanweiResult',
            component: require('@/page/user/cert/CertDanweiResult'),
        },
        {
            path: '/activityDetail',
            name: 'ActivityDetail2',
            component: require('@/page/activity/ActivityDetail'),
        },
        {
            path: '/activityList',
            name: 'ActivityList',
            component: require('@/page/activity/ActivityList'),
        },
        {
            path: '/competitionOrder',
            name: 'CompetitionOrder',
            component: require('@/page/activity/CompetitionOrder'),
        },
        {
            path: '/queryGrade',
            name: 'QueryGrade',
            component: require('@/page/activity/QueryGrade'),
        },
        {
            path: '/mineIndex',
            name: 'MineIndex',
            component: require('@/page/user/mine/MineIndex'),
        },
        {
            path: '/user-setting',
            name: 'UserSetting',
            component: require('@/page/user/mine/setting/Setting'),
        },
        {
            path: '/address-list',
            name: 'AddressList',
            component: require('@/page/user/mine/address2/AddressList'),
        },
        {
            path: '/addressedit',
            name: 'AddressEdit',
            component: require('@/page/user/mine/address2/AddressEdit'),
        },
        {
            path: '/addressadd',
            name: 'AddressAdd',
            component: require('@/page/user/mine/address2/AddressAdd'),
        },
        {
            path: '/invoice-list',
            name: 'InvoiceList',
            component: require('@/page/user/mine/invoice/InvoiceList'),
        },
        {
            path: '/invoiceedit',
            name: 'InvoiceEdit',
            component: require('@/page/user/mine/invoice/InvoiceEdit'),
        },
        {
            path: '/invoiceadd',
            name: 'InvoiceAdd',
            component: require('@/page/user/mine/invoice/InvoiceAdd'),
        },
        {
            path: '/experience',
            name: 'Experience',
            component: require('@/page/user/mine/experience/Experience'),
        },
        {
            path: '/myactivity',
            name: 'MineActivity',
            component: require('@/page/user/mine/activity/Activity'),
        },
        {
            path: '/myinfo',
            name: 'MyInfo',
            component: require('@/page/user/mine/info/MyInfo'),
        },
        {
            path: '/nomyclub',
            name: 'NoMyClub',
            component: require('@/page/user/mine/club/NoMyClub'),
        },
        {
            path: '/Username',
            name: 'Username',
            component: require('@/page/user/mine/setting/Username'),
        },
        {
            path: '/SetPhone',
            name: 'SetPhone',
            component: require('@/page/user/mine/setting/SetPhone'),
        },
        {
            path: '/myclub',
            name: 'MyClub',
            component: require('@/page/user/mine/club/MyClub'),
        },
        {
            path: '/clubDakejianSihao',
            name: 'ClubDakejianSihao',
            component: require('@/page/user/mine/club/ClubDakejianSihao'),
        },
        {
            path: '/feedback',
            name: 'Feedback',
            component: require('@/page/user/mine/feedback/feedback'),
        },
        {
            path: '/qualifications',
            name: 'Qualifications',
            component: require('@/page/user/mine/qualifications/Qualifications'),
        },
        {
            path: '/collection',
            name: 'Collection',
            component: require('@/page/user/mine/collection/Collection'),
        },
        {
            path: '/cropperImage',
            name: 'CropperImage',
            component: require('@/components/CropperImage'),
        },
        {
            path: '/user-password',
            name: 'UserPassword',
            component: require('@/page/user/mine/setting/Password'),
        },
        {
            path: '/cha-index',
            name: 'ChaIndex',
            component: require('@/page/apps/cha/ChaIndex'),
        },
        {
            path: '/cha-jiaolianList',
            name: 'ChaJiaolianList',
            component: require('@/page/apps/cha/JiaolianList'),
        },
        {
            path: '/cha-caipanList',
            name: 'ChaCaipanList',
            component: require('@/page/apps/cha/CaipanList'),
        },
        {
            path: '/cha-searchIndex',
            name: 'ChaSearchIndex',
            component: require('@/page/apps/cha/SearchIndex'),
        },
        {
            path: '/cha-searchAll',
            name: 'ChaSearchAll',
            component: require('@/page/apps/cha/SearchAll'),
        },
        {
            path: '/cha-searchPerson',
            name: 'ChaSearchPerson',
            component: require('@/page/apps/cha/SearchPerson'),
        },
        {
            path: '/cha-searchSaiMember',
            name: 'ChaSearchSaiMember',
            component: require('@/page/apps/cha/SearchSaiMember'),
        },
        {
            path: '/cha-searchDanwei',
            name: 'ChaSearchDanwei',
            component: require('@/page/apps/cha/SearchDanwei'),
        },
        {
            path: '/cha-searchSai',
            name: 'ChaSearchSai',
            component: require('@/page/apps/cha/SearchSai'),
        },
        {
            path: '/huiyi-apply-beizhu',
            name: 'HuiyiApplyBeizhu',
            component: require('@/page/apps/huiyi/HuiyiApplyBeizhu'),
        },
        {
            path: '/huiyi-confirm-manage',
            name: 'HuiyiConfirmManage',
            component: require('@/page/apps/huiyi/huiyiConfirmManage'),
        },
        {
            path: '/huiyi-confirm-detail',
            name: 'HuiyiConfirmDetail',
            component: require('@/page/apps/huiyi/HuiyiConfirmDetail'),
        },
        {
            path: '/huiyi-refund',
            name: 'HuiyiRefund',
            component: require('@/page/apps/huiyi/HuiyiRefund'),
        },
        
        {
            path: '/huiyi-apply-form-file',
            name: 'HuiyiApplyFormFile',
            component: require('@/page/apps/huiyi/HuiyiApplyFormFile'),
        },
        {
            path: '/huiyi-apply-form-step-1',
            name: 'HuiyiApplyFormStep1',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep1'),
        },
        {
            path: '/huiyi-apply-form-step-2',
            name: 'HuiyiApplyFormStep2',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep2'),
        },
        {
            path: '/huiyi-apply-form-step-c-1',
            name: 'HuiyiApplyFormStepC1',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStepC1'),
        },
        {
            path: '/huiyi-apply-form-step-c-2',
            name: 'HuiyiApplyFormStepC2',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStepC2'),
        },
        {
            path: '/huiyi-apply-form-step-c-5',
            name: 'HuiyiApplyFormStepC5',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStepC5'),
        },
        {
            path: '/huiyi-apply-form-step-jiesong',
            name: 'HuiyiApplyFormStepJiesong',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStepJiesong'),
        },
        {
            path: '/huiyi-apply-form-step-jiesong-confirm',
            name: 'HuiyiApplyFormStepJiesongConfirm',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStepJiesongConfirm'),
        },
        {
            path: '/huiyi-apply-form-step-3',
            name: 'HuiyiApplyFormStep3',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep3'),
        },
        {
            path: '/huiyi-apply-form-step-10',
            name: 'HuiyiApplyFormStep10',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep10'),
        },
        {
            path: '/huiyi-apply-form-step-20',
            name: 'HuiyiApplyFormStep20',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep20'),
        },
        {
            path: '/huiyi-apply-form-step-30',
            name: 'HuiyiApplyFormStep30',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep30'),
        },
        {
            path: '/huiyi-apply-form-step-31',
            name: 'HuiyiApplyFormStep31',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep31'),
        },
        {
            path: '/huiyi-apply-form-step-41',
            name: 'HuiyiApplyFormStep41',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep41'),
        },
        {
            path: '/huiyi-apply-form-step-5',
            name: 'HuiyiApplyFormStep5',
            component: require('@/page/apps/huiyi/HuiyiApplyFormStep5'),
        },
        {
            path: '/huiyi-apply-form-share',
            name: 'HuiyiApplyFormShare',
            component: require('@/page/apps/huiyi/HuiyiApplyFormShare'),
        },
        {
            path: '/huiyi-apply-fapiao',
            name: 'HuiyiApplyFapiao',
            component: require('@/page/apps/huiyi/HuiyiApplyFapiao'),
        },
        {
            path: '/huiyi-exame',
            name: 'HuiyiExame',
            component: require('@/page/apps/huiyi/HuiyiExame'),
        },
        {
            path: '/huiyi-apply-form-success',
            name: 'HuiyiApplyFormSuccess',
            component: require('@/page/apps/huiyi/HuiyiApplyFormSuccess'),
        },
        {
            path: '/huiyi-apply-form-upload-video',
            name: 'HuiyiApplyFormUploadVideo',
            component: require('@/page/apps/huiyi/HuiyiApplyFormUploadVideo'),
        },
        {
            path: '/huiyi-apply-form-exame-upload-video',
            name: 'HuiyiApplyFormExameUploadVideo',
            component: require('@/page/apps/huiyi/HuiyiApplyFormExameUploadVideo'),
        },
        {
            path: '/huiyi-apply-list',
            name: 'HuiyiApplyList',
            component: require('@/page/apps/huiyi/HuiyiApplyList'),
        },
        {
            path: '/huiyi-files-list',
            name: 'HuiyiFilesList',
            component: require('@/page/apps/huiyi/HuiyiFilesList'),
        },
        {
            path: '/wexame-my-exame-list',
            name: 'MyExameList',
            component: require('@/page/apps/wexame/MyExameList'),
        },
        {
            path: '/huiyi-index',
            name: 'HuiyiIndex',
            component: require('@/page/apps/huiyi/HuiyiIndex'),
        },
        {
            path: '/huiyi-index2',
            name: 'HuiyiIndexTow',
            component: require('@/page/apps/huiyi/HuiyiIndexTwo'),
        },
        {
            path: '/huiyi-plan',
            name: 'HuiyiPlan',
            component: require('@/page/apps/huiyi/HuiyiPlan'),
        },
        {
            path: '/huiyi-list',
            name: 'HuiyiList',
            component: require('@/page/apps/huiyi/HuiyiList'),
        },
        {
            path: '/news-list',
            name: 'NewsList',
            component: require('@/page/apps/news/NewsList'),
        },
        {
            path: '/news-detail',
            name: 'NewsDetail',
            component: require('@/page/apps/news/NewsDetail'),
        },
        {
            path: '/course-index',
            name: 'CourseIndex',
            component: require('@/page/apps/course/CourseIndex'),
        },
        {
            path: '/course-list',
            name: 'CourseList',
            component: require('@/page/apps/course/CourseList'),
        },
        {
            path: '/course-detail',
            name: 'CourseDetail',
            component: require('@/page/apps/course/CourseDetail'),
        },
        {
            path: '/course-order-check',
            name: 'CourseOrderCheck',
            component: require('@/page/apps/course/CourseOrderCheck'),
        },
        {
            path: '/my-course-list',
            name: 'MyCourseList',
            component: require('@/page/apps/course/MyCourseList'),
        },
        {
            path: '/page-hangyejinying',
            name: 'PageHangyejinying',
            component: require('@/page/apps/page/Hangyejinying'),
        },
        {
            path: '/page-jigoushezhi',
            name: 'PageJigoushezhi',
            component: require('@/page/apps/page/Jigoushezhi'),
        },
        {
            path: '/page-saishizhaoshang',
            name: 'PageSaishizhaoshang',
            component: require('@/page/apps/page/Saishizhaoshang'),
        },
        {
            path: '/page-guojijiaoliu',
            name: 'PageGuojijiaoliu',
            component: require('@/page/apps/page/Guojijiaoliu'),
        },
        {
            path: '/page-guojijiaoliu-detail',
            name: 'PageGuojijiaoliuDetail',
            component: require('@/page/apps/page/GuojijiaoliuDetail'),
        },
        {
            path: '/page-wenhuaji',
            name: 'PageWenhuaji',
            component: require('@/page/apps/page/Wenhuaji'),
        },
        {
            path: '/page-dakejian',
            name: 'PageDakejian',
            component: require('@/page/apps/page/Dakejian'),
        },
        {
            path: '/page-dianxin',
            name: 'PageDianxin',
            component: require('@/page/apps/page/Dianxin'),
        },
        {
            path: '/page-331',
            name: 'Page331',
            component: require('@/page/apps/page/331'),
        },
        {
            path: '/page-2022331',
            name: 'Page2022331',
            component: require('@/page/apps/page/2022331'),
        },
        {
            path: '/page-yundongyuandengji',
            name: 'PageYundongyuandengji',
            component: require('@/page/apps/page/Yundongyuandengji'),
        },
        {
            path: '/cba-apply-list',
            name: 'CbaApplyList',
            component: require('@/page/apps/cba/CbaApplyList'),
        },
        {
            path: '/cba-apply-detail',
            name: 'CbaApplyDetail',
            component: require('@/page/apps/cba/CbaApplyDetail'),
        },
        {
            path: '/cba-apply-form-basic',
            name: 'CbaApplyFormBasic',
            component: require('@/page/apps/cba/CbaApplyFormBasic'),
        },
        {
            path: '/cba-apply-member-list',
            name: 'CbaApplyMemberList',
            component: require('@/page/apps/cba/CbaApplyMemberList'),
        },
        {
            path: '/cba-apply-member-add',
            name: 'CbaApplyMemberAdd',
            component: require('@/page/apps/cba/CbaApplyMemberAdd'),
        },
        {
            path: '/cba-apply-member-detail',
            name: 'CbaApplyMemberDetail',
            component: require('@/page/apps/cba/CbaApplyMemberDetail'),
        },
        {
            path: '/cba-apply-form-order',
            name: 'CbaApplyFormOrder',
            component: require('@/page/apps/cba/CbaApplyFormOrder'),
        },
        {
            path: '/goodsList',
            name: 'GoodsList',
            component: require('@/page/index/goods/GoodsList'),
            meta: {
                keepAlive: true,
                isBack: false
            }
        },
        {
            path: '/goodslist2',
            name: 'GoodsList2',
            component: require('@/page/index/goods/GoodsList2'),
            meta: {
                keepAlive: true,
                isBack: false
            }
        },
        {
            path: '/goodsvideo',
            name: 'GoodsVideo',
            component: require('@/page/index/goods/GoodsVideo'),
        },
        {
            path: '/goodsdetail',
            name: 'GoodsDetail',
            component: require('@/page/index/goods/GoodsDetail'),
        },
        {
            path: '/goodscomment',
            name: 'GoodsComment',
            component: require('@/page/index/goods/GoodsComment'),
        },
        {
            path: '/shopgoodsdetail',
            name: 'ShopGoodsDetail',
            component: require('@/page/index/goods/ShopGoodsDetail'),
        },
        {
            path: '/goodsSellerShare',
            name: 'GoodsDetailSellerShare',
            component: require('@/page/index/goods/GoodsDetailSellerShare'),
        },
        {
            path: '/shopGoodsSellerShare',
            name: 'ShopGoodsDetailSellerShare',
            component: require('@/page/index/goods/ShopGoodsDetailSellerShare'),
        },
        {
            path: '/ordercheck',
            name: 'OrderCheck',
            component: require('@/page/index/order/OrderCheck'),
        },
        {
            path: '/shopordercheck',
            name: 'ShopOrderCheck',
            component: require('@/page/index/order/ShopOrderCheck'),
        },
        {
            path: '/tuandetail',
            name: 'TuanDetail',
            component: require('@/page/apps/tuan/TuanDetail'),
        }, {
            path: '/tuanshare',
            name: 'TuanShare',
            component: require('@/page/apps/tuan/TuanShare'),
        },
        {
            path: '/tuanlist',
            name: 'TuanList',
            component: require('@/page/apps/tuan/TuanList'),
        },
        {
            path: '/tuanordercheck',
            name: 'TuanOrderCheck',
            component: require('@/page/apps/tuan/TuanOrderCheck'),
        },
        {
            path: '/shoptuanordercheck',
            name: 'ShopTuanOrderCheck',
            component: require('@/page/apps/tuan/ShopTuanOrderCheck'),
        },
        {
            path: '/postdownload',
            name: 'PostDownload',
            component: require('@/page/user/seller/PostDownload'),
        },
        {
            path: '/h5',
            name: 'H5',
            component: require('@/page/index/H5'),
        },
        {
            path: '/orderlist',
            name: 'OrderList',
            component: require('@/page/order/OrderListDemo'),
            meta: {
                keepAlive: true,
                isBack: false
            }
        },
        {
            path: '/orderdetail',
            name: 'OrderDetail',
            component: require('@/page/order/OrderDetail'),
        },
        {
            path: '/cart',
            name: 'Cart',
            component: require('@/page/index/Cart'),
        },
        {
            path: '/gbook',
            name: 'Gbook',
            component: require('@/page/index/Gbook'),
        },
        {
            path: '/goodsIndex',
            name: 'GoodsIndex',
            component: require('@/page/index/GoodsIndex'),
        },
        {
            path: '/goodsSearch',
            name: 'GoodsSearch',
            component: require('@/page/index/Search'),
        },
        {
            path: '/goodsCates',
            name: 'GoodsCates',
            component: require('@/page/index/GoodsCates'),
            // meta: { keepAlive: true }
        },
        {
            path: '/preferentialdetail',
            name: 'PreferentialDetail',
            component: require('@/page/apps/preferential/PreferentialDetail'),
        },
        {
            path: '/preferentialordercheck',
            name: 'PreferentialOrderCheck',
            component: require('@/page/apps/preferential/PreferentialOrderCheck'),
        },

        // {
        //     path: '/listDetail',
        //     name: 'listDetail',
        //     component: require('@/components/Mine/listDetail'),
        //   },
        {
            path: '/contentDetail',
            name: 'ContentDetail',
            component: require('@/page/index/cms/ContentDetail'),
        },
        {
            path: '/expresstrace',
            name: 'ExpressTrace',
            component: require('@/page/order/ExpressTrace'),
        },
        {
            path: '/ordercommentoperate',
            name: 'OrderCommentOperate',
            component: require('@/page/order/OrderCommentOperate'),
        },
        {
            path: '/vip',
            name: 'Vip',
            component: require('@/page/user/vip'),
        },
        /**************wyh seabert****************/
        {
            path: '/devicetest',
            name: 'Devicetest',
            component: require('@/page/weiyuanhui/index/Devicetest'),
        },
        {
            path: '/weiyuanhui-index',
            name: 'WeiyuanhuiIndex',
            component: require('@/page/weiyuanhui/index/WeiyuanhuiIndex'),
        },
        {
            path: '/weiyuanhui-list',
            name: 'WeiyuanhuiList',
            component: require('@/page/weiyuanhui/index/WeiyuanhuiList'),
        },


        {
            path: '/weiyuanhui-site-index',
            name: 'SiteSettingIndex',
            component: require('@/page/weiyuanhui/site/SiteSettingIndex'),
        },
        {
            path: '/weiyuanhui-setting-base',
            name: 'SiteSettingBase',
            component: require('@/page/weiyuanhui/site/SiteSettingBase'),
        },
        {
            path: '/weiyuanhui-setting-user',
            name: 'SiteSettingUser',
            component: require('@/page/weiyuanhui/site/SiteSettingUser'),
        },
        {
            path: '/weiyuanhui-setting-user-create',
            name: 'SiteSettingUserCreate',
            component: require('@/page/weiyuanhui/site/SiteSettingUserCreate'),
        },
        {
            path: '/weiyuanhui-apps-examecenter-list',
            name: 'WyhExameCenterList',
            component: require('@/page/weiyuanhui/apps/qcxj/ExameCenterList'),
        },
        {
            path: '/weiyuanhui-apps-examecenter-detail',
            name: 'WyhExameCenterDetail',
            component: require('@/page/weiyuanhui/apps/qcxj/ExameCenterDetail'),
        },
        {
            path: '/weiyuanhui-apps-club-list',
            name: 'WyhClubList',
            component: require('@/page/weiyuanhui/apps/club/ClubList'),
        },
        {
            path: '/weiyuanhui-apps-club-detail',
            name: 'WyhClubDetail',
            component: require('@/page/weiyuanhui/apps/club/ClubDetail'),
        },
        {
            path: '/weiyuanhui-apps-dakejian-list',
            name: 'WyhDakejianList',
            component: require('@/page/weiyuanhui/apps/dakejian/DakejianList'),
        },
        {
            path: '/weiyuanhui-apps-dakejian-detail',
            name: 'WyhDakejianDetail',
            component: require('@/page/weiyuanhui/apps/dakejian/DakejianDetail'),
        },
        {
            path: '/weiyuanhui-apps-sihao-list',
            name: 'WyhSihaoList',
            component: require('@/page/weiyuanhui/apps/sihao/SihaoList'),
        },
        {
            path: '/weiyuanhui-apps-sihao-detail',
            name: 'WyhSihaoDetail',
            component: require('@/page/weiyuanhui/apps/sihao/SihaoDetail'),
        },
        {
            path: '/weiyuanhui-apps-caipan-list',
            name: 'WyhCaipanList',
            component: require('@/page/weiyuanhui/apps/member/CaipanList'),
        },
        {
            path: '/weiyuanhui-apps-caipan-detail',
            name: 'WyhCaipanDetail',
            component: require('@/page/weiyuanhui/apps/member/CaipanDetail'),
        },
        {
            path: '/weiyuanhui-apps-jiaolian-list',
            name: 'WyhJiaolianList',
            component: require('@/page/weiyuanhui/apps/member/JiaolianList'),
        },
        {
            path: '/weiyuanhui-apps-jiaolian-detail',
            name: 'WyhJiaolianDetail',
            component: require('@/page/weiyuanhui/apps/member/JiaolianDetail'),
        },

        {
            path: '/weiyuanhui-apps-huiyi-apply-list',
            name: 'WyhHuiyiApplyList',
            component: require('@/page/weiyuanhui/apps/huiyi/HuiyiApplyList'),
        },
        {
            path: '/weiyuanhui-apps-huiyi-apply-detail',
            name: 'WyhHuiyiApplyDetail',
            component: require('@/page/weiyuanhui/apps/huiyi/HuiyiApplyDetail'),
        },
        {
            path: '/weiyuanhui-apps-sai-apply-list',
            name: 'WyhSaiApplyList',
            component: require('@/page/weiyuanhui/apps/sai/SaiApplyList'),
        },
        {
            path: '/weiyuanhui-apps-saiqu-apply-list',
            name: 'WyhSaiQuApplyList',
            component: require('@/page/weiyuanhui/apps/sai/SaiquApplyList'),
        },
        {
            path: '/weiyuanhui-apps-saiqu-apply-form-step1',
            name: 'WyhSaiquApplyFormStep1', 
            component: require('@/page/weiyuanhui/apps/sai/SaiquApplyFormStep1'),
        },
        {
            path: '/weiyuanhui-apps-sai-apply-detail',
            name: 'WyhSaiApplyDetail',
            component: require('@/page/weiyuanhui/apps/sai/SaiApplyDetail'),
        },

        /*********seabert start 2*********/
        {
            path: '/qcxj-exame-apply-list-danwei',
            name: 'ExameApplyListDanwei',
            component: require('@/page/apps/qcxj/ExameApplyListDanwei'),
        },
        {
            path: '/cha-searchExame',
            name: 'ChaSearchExame',
            component: require('@/page/apps/cha/SearchExame'),
        },

        {
            path: '/weiyuanhui-detail',
            name: 'WeiyuanhuiDetail',
            component: require('@/page/weiyuanhui/index/WeiyuanhuiDetail'),
        },
        {
            path: '/experience-my-experience',
            name: 'MyExperience',
            component: require('@/page/apps/experience/MyExperience'),
        },
        {
            path: '/activity-my-topic',
            name: 'MyTopic',
            component: require('@/page/apps/activity/MyTopic'),
        },
        /*********seabert end 2*********/
        {
            path: '/serviceapply',
            name: 'ServiceApply',
            component: require('@/page/order/ServiceApply'),
        },
        {
            path: '/serviceapplylist',
            name: 'ServiceApplyList',
            component: require('@/page/order/ServiceApplyList'),
        },

        {
            path: '/user-skill-applylist',
            name: 'LevelApplyList',
            component: require('@/page/user/skill/LevelApplyList'),
        },
        {
            path: '/user-skill-memberlist',
            name: 'LevelApplyMemberList',
            component: require('@/page/user/skill/LevelApplyMemberList'),
        },

        {
            path: '/user-ability-applylist',
            name: 'AbilityApplyList',
            component: require('@/page/user/skill/AbilityApplyList'),
        },
        {
            path: '/user-ability-memberlist',
            name: 'AbilityApplyMemberList',
            component: require('@/page/user/skill/AbilityApplyMemberList'),
        },

        {
            path: '/user-ability-member-service',
            name: 'AbilityApplyMemberService',
            component: require('@/page/user/skill/AbilityApplyMemberService'),
        },

        {
            path: '/cha-searchAllResult',
            name: 'ChaSearchAllResult',
            component: require('@/page/apps/cha/SearchAllResult'),
        },
        /*********seabert end 3*********/

        {
            path: '/songpei-apply-form-step1',
            name: 'SongpeiApplyFormStep1',
            component: require('@/page/apps/songpei/SongpeiApplyFormStep1'),
        },

        {
            path: '/songpei-apply-form-step3',
            name: 'SongpeiApplyFormStep3',
            component: require('@/page/apps/songpei/SongpeiApplyFormStep3'),
        },
        /*********seabert end 4*********/

        {
            path: '/cha-searchCaipan',
            name: 'ChaSearchCaipan',
            component: require('@/page/apps/cha/SearchCaipan'),
        },
        {
            path: '/cha-searchJiaolian',
            name: 'ChaSearchJiaolian',
            component: require('@/page/apps/cha/SearchJiaolian'),
        },
        /*********seabert end 5*********/

        {
            path: '/user-cert-personapply',
            name: 'CertPersonApply',
            component: require('@/page/user/cert/CertPersonApply'),
        },
        {
            path: '/user-cert-personapplyother',
            name: 'CertPersonApplyOther',
            component: require('@/page/user/cert/CertPersonApplyOther'),
        },
        {
            path: '/user-cert-personphoto',
            name: 'CertPersonPhoto',
            component: require('@/page/user/cert/CertPersonPhoto'),
        },

        {
            path: '/user-searchCaipan',
            name: 'UserSearchCaipan',
            component: require('@/page/apps/cha/UserSearchCaipan'),
        },
        {
            path: '/user-searchJiaolian',
            name: 'UserSearchJiaolian',
            component: require('@/page/apps/cha/UserSearchJiaolian'),
        },
        {
            path: '/sai-score-caipan-apply',
            name: 'SaiScoreCaipanApply',
            component: require('@/page/apps/sai/SaiScoreCaipanApply'),
        },

        /*********seabert end 6*********/
        {
            path: '/cdakejian-detail',
            name: 'CDakejianDetail',
            component: require('@/page/apps/cdakejian/DakejianDetail'),
        },

        {
            path: '/crural-list',
            name: 'CRuralList',
            component: require('@/page/apps/crural/RuralList'),
        },
        {
            path: '/crural-detail',
            name: 'CRuralDetail',
            component: require('@/page/apps/crural/RuralDetail'),
        },
        {
            path: '/crural-apply',
            name: 'CRuralApply',
            component: require('@/page/apps/crural/RuralApply'),
        },
        {
            path: '/file-download',
            name: 'FileDownload',
            component: require('@/page/apps/file/FileDownload'),
        },


        /********20211123******/
        {
            path: '/dakejian-apply',
            name: 'DakejianApply',
            component: require('@/page/apps/dakejian/DakejianApply'),
        },
        {
            path: '/dakejian-cert-search',
            name: 'DakejianCertSearch',
            component: require('@/page/apps/dakejian/DakejianCertSearch'),
        },
        {
            path: '/dakejian-apply-result',
            name: 'DakejianApplyResult',
            component: require('@/page/apps/dakejian/DakejianApplyResult'),
        },
        {
            path: '/dakejian-apply-list',
            name: 'DakejianApplyList',
            component: require('@/page/apps/dakejian/DakejianApplyList'),
        },
        {
            path: '/dakejian-apply-share',
            name: 'DakejianApplyShare',
            component: require('@/page/apps/dakejian/DakejianApplyShare'),
        },
        {
            path: '/dakejian-apply-member-share',
            name: 'DakejianApplyMemberShare',
            component: require('@/page/apps/dakejian/DakejianApplyMemberShare'),
        },
        {
            path: '/dakejian-apply-success',
            name: 'DakejianApplySuccess',
            component: require('@/page/apps/dakejian/DakejianApplySuccess'),
        },
        {
            path: '/dakejian-apply-upload-video',
            name: 'DakejianApplyUploadVideo',
            component: require('@/page/apps/dakejian/DakejianApplyUploadVideo'),
        },

        /********20220114*********/
        {
            path: '/caipan-common-score',
            name: 'CommonScore',
            component: require('@/page/apps/score/CommonScore'),
        },
        {
            path: '/scoreuposs',
            name: 'Scoreuposs',
            component: require('@/page/apps/score/ScoreUpOss'),
        },
        {
            path: '/mscoreuposs',
            name: 'MScoreuposs',
            component: require('@/page/apps/score/MScoreUpOss'),
        },
        {
            path: '/scoreShow',
            name: 'ScoreShow',
            component: require('@/page/apps/score/ScoreShow'),
        },
        {
            path: '/scoreShow2',
            name: 'ScoreShow2',
            component: require('@/page/apps/score/ScoreShow2'),
        },
        {
            path: '/scoreShowPro',
            name: 'ScoreShowPro',
            component: require('@/page/apps/score/ScoreShowPro'),
        },
        {
            path: '/scoreShow3',
            name: 'ScoreShow3',
            component: require('@/page/apps/score/ScoreShow3'),
        },
        {
            path: '/jianluShow',
            name: 'JianluShow',
            component: require('@/page/apps/score/JianluShow'),
        },
        {
            path: '/startList',
            name: 'StartList',
            component: require('@/page/apps/score/StartList'),
        },
        {
            path: '/startListOption',
            name: 'StartListOption',
            component: require('@/page/apps/score/StartListOption'),
        },
        {
            path: '/huoli-form',
            name: 'huoliForm',
            component: require('@/page/apps/huoli/HuoliForm'),
        },
        /********20220330*********/
        //销售单下单页
        {
            path: '/orderscheck',
            name: 'OrdersCheck',
            component: require('@/page/index/order/OrdersCheck'),
        },
        //员工配置页
        {
            path: '/configureList',
            name: 'ConfigureList',
            component: require('@/page/apps/configure/ConfigureList'),
        },
        //合伙人配置页
        {
            path: '/partnerconfigureList',
            name: 'PartnerConfigureList',
            component: require('@/page/apps/configure/PartnerConfigureList'),
        },
        //委员会配置页
        {
            path: '/wyhconfigureList',
            name: 'WyhConfigureList',
            component: require('@/page/apps/configure/WyhConfigureList'),
        },
        {
            path: '/configureAdd',
            name: 'ConfigureAdd',
            component: require('@/page/apps/configure/ConfigureAdd'),
        },
        {
            path: '/saleGoodsList',
            name: 'SaleGoodsList',
            component: require('@/page/apps/configure/SaleGoodsList'),
        },
        {
            path: '/saleGoodsAdd',
            name: 'SaleGoodsAdd',
            component: require('@/page/apps/configure/SaleGoodsAdd'),
        },
        {
            path: '/saleOrderList',
            name: 'SaleOrderList',
            component: require('@/page/apps/configure/SaleOrderList'),
        },
        ////合伙人客户订单
        {
            path: '/partnerOrderList',
            name: 'PartnerOrderList',
            component: require('@/page/order/PartnerOrderList'),
            meta: {
                keepAlive: true,
                isBack: false
            }
        },
        {
            path: '/partnerorderdetail',
            name: 'PartnerOrderDetail',
            component: require('@/page/order/PartnerOrderDetail'),
        },
        ////委员会客户订单
        {
            path: '/wyhOrderList',
            name: 'WyhOrderList',
            component: require('@/page/order/WyhOrderList'),
            meta: {
                keepAlive: true,
                isBack: false
            }
        },
        {
            path: '/wyhorderdetail',
            name: 'WyhOrderDetail',
            component: require('@/page/order/WyhOrderDetail'),
        },

        {
            path: '/yeyudengji-cert-detail',
            name: 'YeyudengjiCertDetail',
            component: require('@/page/apps/yeyudengji/YeyudengjiCertDetail'),

        },
        {
            path: '/order-apply-beizhu',
            name: 'OrderApplyBeizhu',
            component: require('@/page/order/OrderApplyBeizhu'),
        },

    ],
})


// WEBPACK FOOTER //
// ./src/router/index.js